var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4279 17.0306L1.33325 12.7827C4.73071 8.24964 10.0373 5.33325 16.0003 5.33325C21.9629 5.33325 27.2691 8.24918 30.6666 12.7817L30.6253 12.8245C28.4488 15.0829 24.7982 14.8571 21.9725 13.4959C20.1569 12.6214 18.1334 12.1333 16.0001 12.1333C11.801 12.1333 8.02761 14.0244 5.4279 17.0306Z",
    fill: "#FAB215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5.42773 17.0306C8.02744 14.0244 11.8008 12.1333 15.9999 12.1333C20.199 12.1333 23.9723 14.0244 26.572 17.0306L24.0485 19.649C22.926 20.8137 21.0288 20.6631 19.6162 19.8749C18.5396 19.2742 17.3082 18.9333 16.0001 18.9333C13.6105 18.9333 11.477 20.0707 10.0749 21.8521L5.42773 17.0306Z",
    fill: "#FAB215"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M10.0748 21.8519L16.0003 27.9998L21.9253 21.852C20.5232 20.0705 18.3896 18.9331 16 18.9331C13.6105 18.9331 11.4769 20.0704 10.0748 21.8519Z",
    fill: "#FAB215"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.5239f6a2b1d59d31fad02f0d786a92a3.svg";
export { ForwardRef as ReactComponent };